<div class="margin" [ngClass]="{'app-light-theme': !themeService.isDark, 'app-dark-theme': themeService.isDark}">
    <section class="info" aria-labelledby="maincontent">
        <h1 id="maincontent" tabindex="-1">{{'Accessibility.Title' | translate}}</h1>
        <p tabindex="0" [innerHTML]="'Accessibility.InfoParagraph' | translate"></p>
    </section>
    <mat-divider class="divider" *ngIf="themeService.isDark"></mat-divider>
    <section class="contact" aria-labelledby="accessibility-contact-heading">
        <h2 id="accessibility-contact-heading" tabindex="0">{{'Accessibility.ContactHeader' | translate}}</h2>
        <h3 tabindex="0" [innerHTML]="'Accessibility.ContactName' | translate"></h3>
        <address class="information" fxLayout="column" fxLayout.gt-md="row">
            <p [innerHTML]="'Accessibility.ContactParagraph' | translate"></p>
            <dl class="contactInfo" fxLayout="column" fxLayout.gt-sm="row">
                <div class="email">
                    <dt>
                        <mat-icon class="icon" aria-hidden="true">mail_outline</mat-icon>
                    </dt>
                    <dd>
                        <a href="mailto:Matthew.Clarke@ontario.ca">{{'Accessibility.EmailLinkText' | translate}}</a>
                        <span class="contact-detail">{{'Accessibility.ContactEmail' | translate}}</span>
                    </dd>
                </div>
                <div class="phone">
                    <dt>
                       <mat-icon class="icon" aria-hidden="true">call</mat-icon>
                    </dt>
                    <dd>
                        <a href="tel:{{getRawPhone()}}">{{'Accessibility.PhoneLinkText' | translate}}</a>
                        <span class="contact-detail">{{'Accessibility.ContactPhone' | translate}}</span>
                    </dd>
                </div>
            </dl>
        </address>
    </section>
</div>